import {
  QuickLinkResource,
  QuickLinkSettings,
} from '@/store/quickLinksResourcesApi';

const QuickLinkUtility = () => {
  const normalizeUrl = (url: string | undefined): string => {
    if (!url) return '';
    return url.startsWith('http') ? url : `https://${url}`;
  };

  const normalizeQuickLinkUrl = (url: string | undefined): string =>
    normalizeUrl(url).replace(/\/+$/, '').toLowerCase();

  const sortItems = (
    items: QuickLinkResource[],
    field: QuickLinkSettings['Sort']['Property'],
    direction: QuickLinkSettings['Sort']['Direction'],
  ) => {
    return [...items].sort((a, b) => {
      if (a.IsPromoted !== b.IsPromoted) {
        return a.IsPromoted ? -1 : 1;
      }

      const first = a[field];
      const second = b[field];

      const result =
        field === 'CreateDate'
          ? new Date(first).getTime() - new Date(second).getTime()
          : first.localeCompare(second);

      return direction === 'asc' ? result : -result;
    });
  };

  return { normalizeUrl, normalizeQuickLinkUrl, sortItems };
};

export default QuickLinkUtility();
